module.exports = __webpack_public_path__ + "static/media/FMB_icon3.673f9e83.svg";